// extracted by mini-css-extract-plugin
export default {"pageLayout":"legal_pageLayout__0sKBV"};